<div class="member-view">
  <div class="modal-header">
    <div class="title">무통장입금</div>
    <button type="button" class="close" (click)="activeModal.dismiss()">&times;</button>
  </div>

  <div class="modal-body">
    <div class="bank">우리은행, 계좌번호 1005-201-542581(한국냉동공조산업협회)</div>
    <div class="txt">무통장 입금 이용시엔 회계팀으로 부터 결제 확인이 완료된 후 유료서비스를 이용가능하며,<br/>
                입금확인은 최대 근무시간 기준(공휴일 제외) 익일부터 이용이 가능합니다.<br/>
                <span class="bold">아래 "무통장안내 확인" 버튼을 꼭 클릭하세요.</span>
    </div>
  </div>

  <div class="modal-footer">
    <button class="close-btn" (click)="setPaymentBank()">무통장안내 확인</button>
  </div>
</div>
